import {toast} from "react-toastify";


export default function ApiHandleSuccessMessage(apiResponse, notify = true) {

    let apiResponseMessage = apiResponse?.message;

    if (apiResponse?.response?.data?.message) {
        apiResponseMessage = apiResponse.response.data?.message;
    }

    if (apiResponse?.data?.message) {
        apiResponseMessage = apiResponse.data?.message;
    }

    if (apiResponse?.data?.message_detail) {
        apiResponseMessage = apiResponse.data?.message_detail;
    }

    if (!apiResponseMessage && apiResponse?.response?.data?.data?.message) {
        apiResponseMessage = apiResponse.response.data?.data?.message;
    }

    if (!apiResponseMessage) {
        apiResponseMessage = 'Ok.'
    }

    if (notify) {
        toast.success(apiResponseMessage)
    }
}


export function ApiHandleErrorMessage(error, notify = true) {

    let errorMessage = 'Something went wrong.'

    if (typeof error !== "undefined") {

        errorMessage = error?.message;

        if (error?.response?.data?.message) {
            errorMessage = error.response.data?.message;
        }

        if (error?.response?.data?.message_detail) {
            errorMessage = error.response.data?.message_detail;
        }

        if (!errorMessage) {
            errorMessage = 'Network error. Please try again later.'
        }

    }


    if (notify) {
        toast.error(errorMessage)
    }
}